  <template>
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3" v-if="customer.selected_service_id == 2">
          <label for="kt_platform" class="col-form-label">Platform</label>
          <select class="form-select" id="kt_platform" v-model="form.kt_platform" @change="changePlatform()">
              <option  v-for="(serverPlatform, index) in serverPlatforms" :key="'kt_platform_'+index" :value="serverPlatform.label">
                  {{ serverPlatform.value }}
              </option>
          </select>
          <v-errors :errors="errorFor('kt_platform')"></v-errors>
        </div>
        <div class="mb-3">
            <label for="cloud_network_id" class="col-form-label">Region</label>
            <select class="form-select" id="cloud_network_id" v-model="form.server_region_id">
              <option value="">Select region</option>
                <option  v-for="(serverRegion, index) in serverRegions" :key="'cloud_network_'+index" :value="serverRegion.id">
                    {{ serverRegion.name }}
                </option>
            </select>
            <v-errors :errors="errorFor('server_region_id')"></v-errors>
        </div>
        <div class="mb-3">
            <label for="name" class="col-form-label">Name</label>
            <input type="text" class="form-control" id="name" v-model="form.name">
            <v-errors :errors="errorFor('name')"></v-errors>
        </div>

        <div class="mb-3">
            <div class="d_flex_start">
                <button type="button" class="btn btn-primary btn-md  width_100p mr_10" :disabled="lyLoading" @click.prevent="submit">Submit</button>
                <button type="button" class="btn btn-danger btn-md  width_100p" @click.prevent="closeModal">Cancel</button>
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
      import {mapGetters} from "vuex";

      export default {
          name: 'SshKeyPairForm',
          props: ['closeModal','loadData', 'editId'],
          data(){
              return {
                lyLoading: false,
                isShowSshDownloadModal: false,
                form: {
                  kt_platform: 'g',
                  server_region_id: '',
                  name: '',
                },
                cloudNetworks: [],
                serverRegions: [],
              }
          },
          created() {
            this.loadServerRegions()
          },
        watch: {
          customer() {
            this.loadServerRegions()
            this.loadData();
          }
        },
        computed: {
          ...mapGetters({
            customer: 'auth/getUserInfo',
          }),
          serverPlatforms(){
            if(this.customer.g_platform && this.customer.d_platform){
              return [
                {label: 'g', value: 'G'},
                {label: 'd', value: 'D'},
              ];
            }else if(this.customer.g_platform){
              return [
                {label: 'g', value: 'G'},
              ];
            }else if(this.customer.d_platform){
              return [
                {label: 'd', value: 'D'},
              ];
            }else{
              return [
                {label: 'g', value: 'G'},
              ];
            }
          }
        },
          methods: {
            changePlatform() {
                this.loadServerRegions()
            },
            loadServerRegions() {
              this.axios.get('/server-regions/'+this.form.kt_platform)
              .then(({data}) => {
                  this.serverRegions = data.data
                  if(this.serverRegions.length > 0){
                      this.form.server_region_id = this.serverRegions[0].id
                  }else{
                      this.form.server_region_id = ''
                  }
              })
            },
            loadCloudNetworks() {
                this.axios.get('/cloud-networks')
                .then(({data}) => {
                    this.cloudNetworks = data.data
                    if(this.cloudNetworks.length > 0){
                        this.form.cloud_network_id = this.cloudNetworks[0].id
                    }
                })
            },
            submit() {
              this.allErrors = null;
              this.lyLoading = true;
              
              this.axios.post('/ssh-keypairs', this.form)
              .then(({ data }) => {
                  if(data.success){
                      this.showSuccessMsg(data.message);
                      this.closeModal()
                    this.loadData()
                    this.$emit('setCreatedRecord', data.data)
                    this.sshKeyDownloadModalOpen()
                  }else{
                    this.$swal({
                        text: data.message,
                        showCancelButton: false,
                        confirmButtonText: 'Close!',
                        confirmButtonColor: '#dd4b39',
                        reverseButtons: true
                    })
                  }
              })
              .catch((err) => {
                this.allErrors = err.response?.data?.errors
                if (this.allErrors) {
                    this.showFailMsg(err.response?.data?.message);
                  }
                })
                .finally(() => {
                    this.lyLoading = false;
                })
            },
          }
      }
  </script>
  <style scoped>

  </style>
  